import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import SettingsSidebar from "../../sidebar";
import { Alert, confirm } from "modules/theme";
import { MenuItem } from "react-bootstrap";
import { CenterFlexRow, BackButton } from "../../styles";
import { CustomDropdown } from "modules/common/components";
import APIManager from "modules/common/apiManager";
import { Row, RowTitle, Box, BoxName, Divider } from "../../main/styles";
import { BarItems } from "modules/theme";
import { Modal } from "react-bootstrap";
import { FiInfo, FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalFooter } from "modules/theme";
import WhatsappTemplateAddEdit from "./WhatsappTemplateAddEdit";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  SeachForm,
  ImportFile,
  DataWrapperClass,
  ButtonCommonTheme,
  Icon,
  SettingDropdownMenu,
} from "modules/theme";
import { leftSidebarType, modalType } from "../../../../../helpers/dotenv";
import { MdOutlineAdd } from "react-icons/md";
import { OverflowClass } from "modules/theme";
import styled from "styled-components";
const ModalCSS = styled.div`
  .modal.fade.in .modal-dialog {
    width: 1200px !important;
  }
`;

export class WhatsappTemplate extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `WhatsApp Template`;
    // this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModalShow = this.closeModalShow.bind(this);
    // this.openModalShow = this.openModalShow.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      infoData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      show: false,
    };
  }
  handleModal() {
    this.setState({ show: !this.state.show });
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    // const ary = [];
    const list = this.state.SelectedList.map((data) => {
      // ary = data._id;
      this.state.ary.push(data._id);
      // this.setState({ ary: data._id });
      console.log("data", this.state.ary);
    });
    this.mAPI.sendPostAPI(
      `wp-templete/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        _this.setState({
          SelectedList: [],
          MasterChecked: false,
          SingleChecked: false,
        });
        this.getWhatsappProvider(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`${this.moduleName} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  search(e) {
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value, currentPage: 1 });
        this.getWhatsappProvider(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  componentDidMount() {
    this.getWhatsappProvider(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }

  // handleModalShowHide() {
  //   this.setState({ showHide: !this.state.showHide });
  // }

  getWhatsappProvider(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `wp-templete?limit=${perPage}&page_no=${page}&orderBy=create_at&order=DESC&search=${searchText}`,
      (data) => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  onPaginationChange(page) {
    console.log("onPaginationChange", page);
    this.setState({ currentPage: page });
    this.getWhatsappProvider(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    console.log("onPerPageChooser", perPage);
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getWhatsappProvider(1, perPage, this.state.search);
  }

  closeModalShow() {
    this.setState({ show: false });
  }
  openModalShow(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({
        showHide: true,
        infoData: undefined,
        editData: undefined,
      });
    }
    // this.setState({ show: true });
  }

  closeModal(isUpdated) {
    console.log("isUpdated", isUpdated);
    this.setState({ showHide: false });
    if (isUpdated === true) {
      this.getWhatsappProvider(this.state.currentPage, this.state.perPageCount, this.state.search);
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, infoData: data });
    } else {
      this.setState({ showHide: true, infoData: undefined });
    }
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  onChange() {}

  onSingleChange(e, company) {}

  editTemplate(template) {
    return (
      <ButtonCommonTheme
        type="edit"
        editOnClick={() => this.openModal(template)}
      />
    );
  }
  deleteTemplate(template) {
    var that = this;
    this.mAPI.sendPostAPI(
      `wp-templete/${template._id}`,
      undefined,
      (data) => {
        that.getWhatsappProvider(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`${template.name} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }
  renderActions(template, index) {
    const { __ } = this.context;
    return (
      <ActionButtons>
        {this.editTemplate(template)}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem>
            <a
              onClick={(e) =>
                confirm().then((e) => {
                  this.deleteTemplate(template, e);
                })
              }
            >
              {"Delete"}
            </a>
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    // formData.append('contactListId', this.state.search);
    return formData;
  }

  handleClose() {
    this.setState({ show: false });
  }
  handleShow() {
    this.setState({ show: true });
  }
  onClick() {
    this.setState({ show: true });
  }
  renderActionBar() {
    let _this = this;
    const ImportTrigger = ({ onClick }) => {
      console.log("typeProps", onClick);
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalCSS>
          <ModalTrigger
            title="Create Template Message"
            trigger={<ImportTrigger />}
            size="lg"
            showHide={this.state.showHide}
            closeModal={this.closeModal}
            openModal={this.openModal}
            openModalShow={this.openModalShow}
            dialogClassName={this.state.modalType}
          >
            <WhatsappTemplateAddEdit
              update={() => this.setState({ currentPage: 1 })}
              size="small"
              isEdit={false}
              editData={this.state.editData}
              infoData={this.state.infoData}
              closeModal={this.closeModal}
              modalType={this.state.modalType}
            />
          </ModalTrigger>
        </ModalCSS>
      </span>
    );
  }
  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Message Setting"), link: "/message" },
      { title: __("WhatsApp Template"), link: "/settings/whatsapp-template" },
    ];

    const mainContent = (
      <DataWrapperClass className="tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th>{__("NAME")}</th>
              <th>{__("Categories")}</th>
              <th>{__("Language")}</th>
              <th>{__("Portal Status")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="template">
            {this.state.listData &&
              this.state.listData.map((template, index) => (
                <tr key={template._id}>
                  <td>{template.templeteName}</td>
                  <td>{template.categoris}</td>
                  <td>{template.languge}</td>
                  <td>{template.templateStatus || ""}</td>
                  <td>{this.renderActions(template, index)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
        {/* </OverflowClass> */}
      </DataWrapperClass>
    );
    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              // <ControlLabel>{this.moduleName}</ControlLabel>
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{this.moduleName}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    {/* <ControlLabel>{`SIP Extensions (${this.state.total || 0})`}</ControlLabel> */}
                    <SeachForm>
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                    </SeachForm>
                    {this.state.SelectedList.length > 0 ? (
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    ) : (
                      ""
                    )}
                  </div>
                }
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText=""
                  emptyImage="/images/emptySIP.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}
WhatsappTemplate.contextTypes = {
  __: PropTypes.func,
};

export default WhatsappTemplate;



// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsappTemplate/components/WhatsappTemplate.js